module.exports = __webpack_public_path__ + "img/profile-photo.e4f4ee73.jpg";